import { type Location, type PropertyFiltersType } from '@aikoa/common'
import { create } from 'zustand'

export type LeadManualFilter = {
  filters: PropertyFiltersType
  locations: Location[]
}

export type ManualFilterUpdater =
  | LeadManualFilter
  | ((current: LeadManualFilter) => LeadManualFilter)

export type LeadFilterMode = 'asset' | 'manual'

type LeadStoreType = {
  offerAssetId?: string
  setOfferAssetId: (offerAssetId?: string) => void
  manualFilter: LeadManualFilter
  setManualFilter: (updater: ManualFilterUpdater | null) => void
  resetManualFilter: () => void
  activeFilterMode: LeadFilterMode
  setActiveFilterMode: (mode: LeadFilterMode) => void
  agreementAccepted: boolean
  setAgreementAccepted: (accepted: boolean) => void
  reset: () => void
}

const emptyManualFilter: LeadManualFilter = {
  filters: {},
  locations: [],
}

const isManualFilterUpdaterFunction = (
  updater: ManualFilterUpdater
): updater is (current: LeadManualFilter) => LeadManualFilter => typeof updater === 'function'

export const useLeadStore = create<LeadStoreType>((setState) => ({
  offerAssetId: undefined,
  setOfferAssetId: (offerAssetId) =>
    setState({
      offerAssetId: offerAssetId || undefined,
    }),
  manualFilter: emptyManualFilter,
  setManualFilter: (updater) =>
    setState((state) => {
      if (!updater) {
        return {
          manualFilter: emptyManualFilter,
        }
      }

      return {
        manualFilter: isManualFilterUpdaterFunction(updater)
          ? updater(state.manualFilter)
          : updater,
      }
    }),
  resetManualFilter: () =>
    setState({
      manualFilter: emptyManualFilter,
    }),
  activeFilterMode: 'manual',
  setActiveFilterMode: (mode) => setState({ activeFilterMode: mode }),
  agreementAccepted: false,
  setAgreementAccepted: (accepted) => setState({ agreementAccepted: accepted }),
  reset: () => setState({ offerAssetId: undefined, agreementAccepted: false }),
}))
